/// <amd-module name="Artifacts/Cargo/redux/Module" />
import { rootSaga } from "Artifacts/Cargo/redux/Sagas";
import { PackageModule } from "Artifacts/Package/redux";
import { ISagaModule } from "redux-dynamic-modules-saga";

const _CargoModule: ISagaModule<Record<string, never>> = {
  id: "cargo-protocol-module",
  reducerMap: {},
  sagas: [rootSaga],
};

export const CargoModule = [PackageModule, _CargoModule];
